/* eslint-disable */
import React from "react";
import { TextField, TextFieldProps, Avatar, Fade, SvgIcon, Tooltip } from "@material-ui/core";
import { ComboBoxField } from "../../../../components/ComboBoxField";
import { isIE } from "react-device-detect";
import { CloudUpload, Delete } from "@material-ui/icons";
import { MessageDescriptor, FormattedMessage, useIntl } from "react-intl";

import { useStyles } from "./styles";
import { useUserInfo } from "./useUserInfo";
import { useDepartments, Department } from "../../../dictionaries/shared";
import { UserActions } from "../UserActions";
import messages from "./messages";
import { notistackService } from "../../../notistack/shared";
import { localeService } from "../../../locale/dependencyInjection";

const MAX_FILE_SIZE = 2 * 1024 * 1024; //2 MB

export const UserInfo: React.FC = (props) => {
  const intl = useIntl();
  const classes = useStyles(props);
  const {
    name,
    surname,
    department,
    image,
    setDepartment,
    setImage,
    setName,
    setSurname,
    apply,
    resetUserInfo,
    validation,
    profilePicture,
    setProfilePicture,
  } = useUserInfo();
  const [, departmentsWithNamesDeleted] = useDepartments();
  const [nameError, setNameError] = React.useState(false);
  const [surnameError, setSurnameError] = React.useState(false);
  const [departmentError, setDepartmentError] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState<boolean>(false);
  const [isDirtyForm, setIsDirtyForm] = React.useState<boolean>(false);
  const [inputKeyToggler, setInputKeyToggler] = React.useState<boolean>(false);
  const [isNeedRenderDepatment, setIsNeedRenderDepatment] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (department && name && surname) {
      setIsNeedRenderDepatment(true);
    }
  }, [department, name, surname]);

  const sharedFieldProps: TextFieldProps = {
    InputLabelProps: {
      className: classes.fieldName,
      shrink: isIE ? true : undefined,
    },
    FormHelperTextProps: { classes: { root: classes.helperText } },
    className: classes.fieldContent,
  };

  const toggleInputKey = () => {
    setInputKeyToggler(!inputKeyToggler);
  };

  const getImage = (event: any) => {
    const file = event.target.files[0];
    if (file.size > MAX_FILE_SIZE && intl) {
      notistackService.createSnackbar({
        message: intl.formatMessage(messages.fileIsTooBig),
        variant: "error",
      });
      toggleInputKey();
      return;
    }
    setImage(file);
    toggleInputKey();
    setIsDirtyForm(true);
  };

  const getProfilePicture = () => {
    if (image) {
      return URL.createObjectURL(image);
    } else {
      if (profilePicture) {
        return profilePicture;
      } else {
        return "";
      }
    }
  };

  const resetPicture = () => {
    setImage(undefined);
    setProfilePicture("");
    setIsDirtyForm(true);
  };

  const handleChangeDepartment = (event: React.ChangeEvent<{}>, value: any) => {
    if (value) {
      setDepartment(value.id);
      setDepartmentError(false);
    } else {
      setDepartment(0);
      setDepartmentError(true);
    }
    setIsDirtyForm(true);
  };

  const getPhotoMenu = () => {
    const imageUrl = getProfilePicture();
    const message: MessageDescriptor = imageUrl ? messages.changePhoto : messages.addPhoto;
    return (
      <div className={classes.photoMenuRoot}>
        <Tooltip title={<FormattedMessage {...messages.inputFileTooltip} />}>
          <label htmlFor="fileInput">
            <div className={classes.inputFileLabelItem}>
              <SvgIcon className={classes.inputFileLabelIcon}>
                <CloudUpload />
              </SvgIcon>
              <FormattedMessage {...message} />
            </div>
          </label>
        </Tooltip>
        {imageUrl && (
          <div className={classes.inputFileLabelItem} onClick={resetPicture}>
            <SvgIcon className={classes.inputFileLabelIcon}>
              <Delete />
            </SvgIcon>
            <FormattedMessage {...messages.deletePhoto} />
          </div>
        )}
      </div>
    );
  };

  const handleApply = () => {
    apply();
    setIsDirtyForm(false);
  };

  const handleCancel = () => {
    setImage(undefined);
    resetUserInfo();
    setIsDirtyForm(false);
  };

  const avatarSrc = getProfilePicture();

  return (
    <>
      <div className={classes.root}>
        {isIE ? (
          <div className={classes.avatarIE} onMouseOver={() => setShowMenu(true)} onMouseOut={() => setShowMenu(false)}>
            <img
              src={avatarSrc || `${process.env.PUBLIC_URL}/assets/images/Profile_avatar_placeholder_large.png`}
              className={classes.avatarIEImage}
            />
            <input
              key={inputKeyToggler ? 1 : 0}
              type="file"
              name="fileInput"
              id="fileInput"
              accept=".png,.jpg,.jpeg"
              onChange={getImage}
              className={classes.inputFile}
            />
            <Fade in={showMenu}>{getPhotoMenu()}</Fade>
          </div>
        ) : (
          <div
            className={classes.photoRoot}
            onMouseOver={() => setShowMenu(true)}
            onMouseOut={() => setShowMenu(false)}
          >
            <Avatar variant="square" src={avatarSrc} className={classes.avatar} />
            <input
              key={inputKeyToggler ? 1 : 0}
              type="file"
              name="fileInput"
              id="fileInput"
              accept=".png,.jpg,.jpeg"
              onChange={getImage}
              className={classes.inputFile}
            />
            <Fade in={showMenu}>{getPhotoMenu()}</Fade>
          </div>
        )}
        <div className={classes.inputFormRoot}>
          <div className={classes.fieldItem}>
            <TextField
              {...sharedFieldProps}
              id="name"
              variant="outlined"
              label={<FormattedMessage {...messages.name} />}
              error={nameError && !!validation.nameErrors.length}
              helperText={
                nameError && validation.nameErrors.length ? <FormattedMessage {...validation.nameErrors[0]} /> : null
              }
              value={name}
              onChange={({ target }) => {
                setIsDirtyForm(true);
                setName(target.value);
              }}
              onFocus={() => setNameError(false)}
              onBlur={() => setNameError(true)}
            />
          </div>
          <div className={classes.fieldItem}>
            <TextField
              {...sharedFieldProps}
              label={<FormattedMessage {...messages.surname} />}
              id="suname"
              variant="outlined"
              error={surnameError && !!validation.surnameErrors.length}
              helperText={
                surnameError && validation.surnameErrors.length ? (
                  <FormattedMessage {...validation.surnameErrors[0]} />
                ) : null
              }
              value={surname}
              onChange={({ target }) => {
                setIsDirtyForm(true);
                setSurname(target.value);
              }}
              onFocus={() => setSurnameError(false)}
              onBlur={() => setSurnameError(true)}
            />
          </div>
          <div className={classes.fieldItem}>
            <ComboBoxField
              key={
                departmentsWithNamesDeleted && departmentsWithNamesDeleted[0] && isNeedRenderDepatment
                  ? departmentsWithNamesDeleted[0].id
                  : "nodata"
              }
              options={departmentsWithNamesDeleted}
              getOptionLabel={(option) => option.name}
              inputLabel={messages.department}
              defaultValue={departmentsWithNamesDeleted.find((item) => item.id === department)}
              filterOptions={(options: Department[], state: any) => {
                return options.filter(
                  (item) =>
                    item.isDeleted === false &&
                    (!!state.inputValue.length
                      ? item.name.toLowerCase().includes(state.inputValue.toLowerCase())
                      : true),
                );
              }}
              onChange={handleChangeDepartment}
              inputLabelClassName={classes.inputLabel}
              className={classes.fieldContent}
              error={departmentError}
              helperText={(departmentError && <FormattedMessage {...messages.fieldIsRequired} />) || undefined}
            />
          </div>
          <UserActions
            onApply={handleApply}
            onCancel={handleCancel}
            valid={isDirtyForm && validation.validUserInfo && !departmentError}
          />
        </div>
      </div>
    </>
  );
};
